import styled from "styled-components/macro"
import Color from "../../../constants/Color"

export const Container = styled.div`
  background: url("https://i.ibb.co/56krc3z/last-bg.png");
  /* background: linear-gradient(359.56deg, #f5f5f5 2.11%, rgba(245, 245, 245, 0) 99.66%); */
`
export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

export const Content = styled.div`
  flex: 3;
  padding: 16px 16px;
  /* background: url("https://i.ibb.co/fHTQg4j/Last.png"); */

  background-size: fill;

  @media (min-width: 640px) {
    padding: 16px 0px;
  }
`

export const Thumbnail = styled.div`
  display: none;

  @media (min-width: 640px) {
    display: block;
    width: 240px;
    height: 100%;
    padding: 30px;
    padding-right: 0;
  }
`

export const Image = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 4px;
  overflow: hidden;
`
export const Title = styled.h4`
  color: ${Color.gray800};
  font-size: 16px;
  margin-bottom: 8px;

  @media (min-width: 1280px) {
    font-size: 20px;
  }
`

export const Date = styled.span`
  font-weight: 100;
`

export const Subtitle = styled.h4`
  color: ${Color.gray800};
  font-size: 16px;
  margin-bottom: 8px;

  @media (min-width: 1280px) {
    font-size: 18px;
  }
`
export const Episode = styled.p`
  width: 100%;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 24px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: ${Color.gray600};
`

export const Text = styled.p`
  width: 100%;
  font-size: 14px;
  margin-bottom: 24px;
  line-height: 20px;
  letter-spacing: 0.5px;
  color: ${Color.gray600};

  @media (min-width: 1280px) {
    font-size: 16px;
  }
`

export const SeasonAndDate = styled.div`
  margin-bottom: 8px;
  display: flex;
`

export const IconWithText = styled.div`
  display: flex;
  align-items: center;
  color: ${Color.gray600};
  font-size: 12px;
  margin-right: 12px;

  @media (min-width: 1280px) {
    font-size: 14px;
  }

  & i {
    font-size: 16px;
    color: ${Color.gray600};
    margin-right: 4px;
  }

  &::after {
    content: "|";
    margin-left: 12px;
  }
  &:last-child::after {
    content: "";
  }
`
